import { useState } from "react";
import ReactPlayer from "react-player";
import { Img } from "react-image";
import styles from "../../communication-chat.module.css";
import { X } from "react-feather";

const IdentityMessageFileViewer = ({ media }) => {
  const [fullImage, setFullImage] = useState(false);

  const renderFileContent = (fileUrl, contentType) => {
    if (contentType.startsWith("image/")) {
      return (
        <div onClick={() => setFullImage(true)} className={`${styles.ImgFile}`}>
          <Img src={fileUrl} alt="" />
        </div>
      );
    } else if (contentType.startsWith("video/")) {
      return (
        <div className={`${styles.ImgFile}`}>
          <ReactPlayer url={fileUrl} controls />
        </div>
      );
    } else if (contentType.startsWith("audio/")) {
      return <audio src={fileUrl} controls />;
    } else {
      return (
        <div
          style={{
            width: "220px",
            maxWidth: "220px",
            overflow: "visible",
            whiteSpace: "normal",
            padding: "10px",
            boxSizing: "border-box",
          }}
        >
          <p
            className={`${styles.NoFileTT}`}
            style={{
              wordBreak: "break-word",
              whiteSpace: "normal",
              fontSize: "13px",
            }}
          >
            Preview is not available for this file type..
          </p>

          <a
            className={`${styles.NoFileDrBU}`}
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "inline-block", marginTop: "6px" }}
          >
            Download File
          </a>
        </div>
      );
    }
  };

  return (
    <>
      {media.map((file, index) => (
        <div key={index}>
          {renderFileContent(file.url, file.content_type)}
          {fullImage && (
            <div
              className={`${styles.ImgFilePops} ${
                fullImage ? styles.Active : ""
              }`}
            >
              <Img src={file.url} alt="" />
              <button
                onClick={() => setFullImage(false)}
                className={`${styles.CancelImgBU}`}
              >
                <X />
              </button>
            </div>
          )}
        </div>
      ))}
    </>
  );
};

export default IdentityMessageFileViewer;
